import axios from "axios";
import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchRoverDataFailure,
  fetchRoverDataStart,
  fetchRoverDataSuccess,
} from "../../../store/features/customer/roverData/roverDataSlice";

const URL = `${process.env.REACT_APP_MOCKAPI_URL}rover-data`;

const getRoverDataApi = async (fieldId) => {
  try {
    const params = fieldId ? { field_id: fieldId } : {};
    const response = await axios.get(URL, { params });
    return response.data;
  } catch (error) {
    const errorMessage = error.response?.data?.message || error.message;
    throw new Error(errorMessage);
  }
};

function* fetchRoverDataSaga(action) {
  try {
    const roverData = yield call(getRoverDataApi, action.payload);
    yield put(fetchRoverDataSuccess(roverData));
  } catch (error) {
    yield put(fetchRoverDataFailure(error.message));
  }
}

export default function* roverDataSaga() {
  yield takeLatest(fetchRoverDataStart.type, fetchRoverDataSaga);
}
